import {roseRepoServer} from "@/HttpServer.js"

	 /**
	 * download
	 * 接口路径: /common/download
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} queryParams.file - file (必选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getCommonDownloadApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/common/download',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 /**
	 * upload
	 * 接口路径: /common/upload/file
	 * 请求方法: POST
	 * @param {FormData} formData - 表单数据
	 * @param {File} [formData.file] - 无描述 (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const uploadFileApi = (formData) =>
	 {
	     const config = {
	         url: '/common/upload/file',
	         oauth: true,
	         headers: {
	             'Content-Type': 'multipart/form-data',
	         },
	         data: formData,
	     };
	     return roseRepoServer.post(config);
	 };
	 /**
	 * copyWriting
	 * 接口路径: /module/copywriting
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.type] - type (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getCopyWritingApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/copywriting',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * detail
	 * 接口路径: /module/detail
	 * 请求方法: GET
	 * @param {Object} headers - 请求头参数
	 * @param {string} headers.Authorization - Authorization (必选)
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.chargeMode] - charge mode (可选)
	 * @param {string} [queryParams.moduleName] - module name (可选)
	 * @param {string} [queryParams.moduleVersion] - module version (可选)
	 * @param {integer} [queryParams.moduleVersionId] - module version id (可选)
	 * @param {string} [queryParams.username] - username (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleDetailApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/detail',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * disable module
	 * 接口路径: /module/disable
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {number} [bodyData.moduleId] - module id (必选)
	 * @param {number} [bodyData.workstationId] - workstation Id (可选)
	 * @param {string} [bodyData.path] - path (可选)
	 * @param {string} [bodyData.envType] - env type: parentEnv,childEnv (可选)
	 * @param {string} [bodyData.envName] - env name: parent-codigger-release,parent-codigger-earlybird,parent-codigger-development (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const moduleDisabledApi = (bodyData) =>
	 {
	     const config = {
	         url: '/module/disable',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * enable module
	 * 接口路径: /module/enable
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {number} bodyData.moduleId - module id (必选)
	 * @param {number} bodyData.workstationId - workstation Id (可选)
	 * @param {string} bodyData.path - path (可选)
	 * @param {string} bodyData.envType - env type: parentEnv,childEnv (可选)
	 * @param {string} bodyData.envName - env name: parent-codigger-release,parent-codigger-earlybird,parent-codigger-development (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const moduleEnableApi = (bodyData) =>
	 {
	     const config = {
	         url: '/module/enable',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * getModuleByIds
	 * 接口路径: /module/getByIds
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} queryParams.data - module names, Splicing through commas (必选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleByIdsApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/getByIds',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * 通过模块名获取模块
	 * 接口路径: /module/getByModuleName
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} queryParams.data - module name (必选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleByModuleNameApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/getByModuleName',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * getModuleVersionList
	 * 接口路径: /module/getModuleVersionList
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} [queryParams.moduleName] - moduleName (可选)
	 * @param {integer} [queryParams.pageNum] - pageNum (可选)
	 * @param {integer} [queryParams.pageSize] - pageSize (可选)
	 * @param {integer} [queryParams.state] - state (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleVersionListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/getModuleVersionList',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * getOfferingList
	 * 接口路径: /module/getOfferingList
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.pageNum] - pageNum (可选)
	 * @param {integer} [queryParams.pageSize] - pageSize (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getOfferingModuleListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/getOfferingList',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * install module
	 * 接口路径: /module/install
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {number} bodyData.workstationId - workstation Id (可选)
	 * @param {string} bodyData.path - path (可选)
	 * @param {string} bodyData.envType - env type: parentEnv,childEnv (可选)
	 * @param {string} bodyData.envName - env name: parent-codigger-release,parent-codigger-earlybird,parent-codigger-development (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const moduleInstallApi = (bodyData) =>
	 {
	     const config = {
	         url: '/module/install',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * list
	 * 接口路径: /module/list
	 * 请求方法: GET
	 * @param {Object} headers - 请求头参数
	 * @param {string} headers.Authorization - Authorization (必选)
	 * @param {Object} queryParams - 查询参数
	 * @param {array} queryParams.catalog - type： 1:Raw，2:Wrapper，xxx (必选)
	 * @param {string} [queryParams.nameLike] - module name fuzzy query (可选)
	 * @param {integer} [queryParams.orderType] - sort order： null/0: sort attribute, 1: most popular (downloads), 2: newest submission, 3: latest modified, 4: recommend (score) (可选)
	 * @param {integer} [queryParams.pageNum] - page number (可选)
	 * @param {integer} [queryParams.pageSize] - page size (可选)
	 * @param {integer} queryParams.userId - gateway user id (必选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/list',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * getMyModuleList
	 * 接口路径: /module/list/my
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.pageNum] - page num (可选)
	 * @param {integer} [queryParams.pageSize] - page size (可选)
	 * @param {string} [queryParams.username] - username (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getMyModuleListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/list/my',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 /**
	 * getRequireApi
	 * 接口路径: /module/require
	 * 请求方法: GET
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getRequireApi = () =>
	 {
	     const config = {
	         url: '/module/require',
	         oauth: true
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * searchModule by workstation id
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} queryParams.moduleName - 无描述 (必选)
	 * @param {integer} [queryParams.workstationId] - 无描述 (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const searchByWorkstationIdApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/searchByWorkstationId',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * getSubmissionDelist
	 * 接口路径: /module/submission/delist
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.moduleId] - moduleId (可选)
	 * @param {string} [queryParams.moduleName] - moduleName (可选)
	 * @param {string} [queryParams.moduleVersion] - moduleVersion (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getSubmissionDelistApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/submission/delist',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * submissionSubmitRelease
	 * 接口路径: /module/submission/release
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.moduleId] - moduleId (可选)
	 * @param {string} [queryParams.moduleName] - moduleName (可选)
	 * @param {string} [queryParams.moduleVersion] - moduleVersion (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const submissionSubmitReleaseApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/submission/release',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * getSubmissionResult
	 * 接口路径: /module/submission/result
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.moduleId] - moduleId (可选)
	 * @param {integer} [queryParams.state] - state (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getSubmissionResultApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/submission/result',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * submissionRevoke
	 * 接口路径: /module/submission/revoke
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.moduleId] - moduleId (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const submissionRevokeApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/submission/revoke',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * submissionSubmit
	 * 接口路径: /module/submission/submit
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.moduleId] - moduleId (可选)
	 * @param {string} [queryParams.moduleName] - moduleName (可选)
	 * @param {string} [queryParams.moduleVersion] - moduleVersion (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const submissionSubmitApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/submission/submit',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * get Top Downloads
	 * 接口路径: /module/top
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {array} queryParams.catalog - type： 1:Raw，2:Wrapper，xxx (必选)
	 * @param {string} [queryParams.nameLike] - module name fuzzy query (可选)
	 * @param {integer} [queryParams.orderType] - sort order： null/0: sort attribute, 1: most popular (downloads), 2: newest submission, 3: latest modified, 4: recommend (score) (可选)
	 * @param {integer} [queryParams.pageNum] - page number (可选)
	 * @param {integer} [queryParams.pageSize] - page size (可选)
	 * @param {integer} queryParams.userId - gateway user id (必选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getTopDownloadsApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/top',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * uninstall module
	 * 接口路径: /module/uninstall
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {number} bodyData.workstationId - workstation Id (可选)
	 * @param {string} bodyData.path - path (可选)
	 * @param {string} bodyData.envType - env type: parentEnv,childEnv (可选)
	 * @param {string} bodyData.envName - env name: parent-codigger-release,parent-codigger-earlybird,parent-codigger-development (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const moduleUninstallApi = (bodyData) =>
	 {
	     const config = {
	         url: '/module/uninstall',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * update module
	 * 接口路径: /module/update
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {number} bodyData.workstationId - workstation Id (可选)
	 * @param {string} bodyData.path - path (可选)
	 * @param {string} bodyData.envType - env type: parentEnv,childEnv (可选)
	 * @param {string} bodyData.envName - env name: parent-codigger-release,parent-codigger-earlybird,parent-codigger-development (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const moduleUpdateApi = (bodyData) =>
	 {
	     const config = {
	         url: '/module/update',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * module updateDetail
	 * 接口路径: /module/update/detail
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {string} bodyData.changeLog - changeLog (可选)
	 * @param {string} bodyData.description - description (可选)
	 * @param {string} bodyData.enChangeLog - enChangeLog (可选)
	 * @param {string} bodyData.enDescription - enDescription (可选)
	 * @param {string} bodyData.enIntroduction - enIntroduction (可选)
	 * @param {string} bodyData.enNaturalName - enNaturalName (可选)
	 * @param {number} bodyData.expired - expired (可选)
	 * @param {string} bodyData.introduction - introduction (可选)
	 * @param {string} bodyData.logo - logo (可选)
	 * @param {number} bodyData.moduleVersionId - moduleVersionId (可选)
	 * @param {string} bodyData.naturalName - naturalName (可选)
	 * @param {number} bodyData.price - price (可选)
	 * @param {number} bodyData.unitType - unitType (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const moduleUpdateDetailApi = (bodyData) =>
	 {
	     const config = {
	         url: '/module/update/detail',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	 /***** Module Management ******/
	 /**
	 * audit module
	 * 接口路径: /management/module/audit
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {number} bodyData.moduleVersionId - moduleVersionId (必选)
	 * @param {number} bodyData.state - state (必选)
	 * @param {string} bodyData.remark - remark (可选)
	 * @param {string} bodyData.sysUsername - sysUsername (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const moduleAuditApi = (bodyData) =>
	 {
	     const config = {
	         url: '/management/module/audit',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * get auditList
	 * 接口路径: /management/module/audit/list
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.end.date] - 无描述 (可选)
	 * @param {integer} [queryParams.end.day] - 无描述 (可选)
	 * @param {integer} [queryParams.end.hours] - 无描述 (可选)
	 * @param {integer} [queryParams.end.minutes] - 无描述 (可选)
	 * @param {integer} [queryParams.end.month] - 无描述 (可选)
	 * @param {integer} [queryParams.end.nanos] - 无描述 (可选)
	 * @param {integer} [queryParams.end.seconds] - 无描述 (可选)
	 * @param {integer} [queryParams.end.time] - 无描述 (可选)
	 * @param {integer} [queryParams.end.timezoneOffset] - 无描述 (可选)
	 * @param {integer} [queryParams.end.year] - 无描述 (可选)
	 * @param {number} [queryParams.expiredFrom] - 无描述 (可选)
	 * @param {number} [queryParams.expiredTo] - 无描述 (可选)
	 * @param {string} [queryParams.name] - 无描述 (可选)
	 * @param {integer} [queryParams.pageNum] - 分页 - 页码 (可选)
	 * @param {integer} [queryParams.pageSize] - 分页 - 页数 (可选)
	 * @param {number} [queryParams.priceFrom] - 无描述 (可选)
	 * @param {number} [queryParams.priceTo] - 无描述 (可选)
	 * @param {string} [queryParams.searchKey] - 无描述 (可选)
	 * @param {integer} [queryParams.start.date] - 无描述 (可选)
	 * @param {integer} [queryParams.start.day] - 无描述 (可选)
	 * @param {integer} [queryParams.start.hours] - 无描述 (可选)
	 * @param {integer} [queryParams.start.minutes] - 无描述 (可选)
	 * @param {integer} [queryParams.start.month] - 无描述 (可选)
	 * @param {integer} [queryParams.start.nanos] - 无描述 (可选)
	 * @param {integer} [queryParams.start.seconds] - 无描述 (可选)
	 * @param {integer} [queryParams.start.time] - 无描述 (可选)
	 * @param {integer} [queryParams.start.timezoneOffset] - 无描述 (可选)
	 * @param {integer} [queryParams.start.year] - 无描述 (可选)
	 * @param {string} [queryParams.state] - 无描述 (可选)
	 * @param {array} [queryParams.userState] - 无描述 (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleAuditListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/management/module/audit/list',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * detail
	 * 接口路径: /management/module/detail
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.moduleVersionId] - moduleVersionId (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getManagementModuleDetailApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/management/module/detail',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * list
	 * 接口路径: /management/module/list
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.catalog] - 无描述 (可选)
	 * @param {boolean} [queryParams.enabled] - 无描述 (可选)
	 * @param {integer} [queryParams.end.date] - 无描述 (可选)
	 * @param {integer} [queryParams.end.day] - 无描述 (可选)
	 * @param {integer} [queryParams.end.hours] - 无描述 (可选)
	 * @param {integer} [queryParams.end.minutes] - 无描述 (可选)
	 * @param {integer} [queryParams.end.month] - 无描述 (可选)
	 * @param {integer} [queryParams.end.nanos] - 无描述 (可选)
	 * @param {integer} [queryParams.end.seconds] - 无描述 (可选)
	 * @param {integer} [queryParams.end.time] - 无描述 (可选)
	 * @param {integer} [queryParams.end.timezoneOffset] - 无描述 (可选)
	 * @param {integer} [queryParams.end.year] - 无描述 (可选)
	 * @param {number} [queryParams.expiredFrom] - 无描述 (可选)
	 * @param {number} [queryParams.expiredTo] - 无描述 (可选)
	 * @param {boolean} [queryParams.hotspot] - 无描述 (可选)
	 * @param {string} [queryParams.name] - 无描述 (可选)
	 * @param {integer} [queryParams.pageNum] - 分页 - 页码 (可选)
	 * @param {integer} [queryParams.pageSize] - 分页 - 页数 (可选)
	 * @param {number} [queryParams.priceFrom] - 无描述 (可选)
	 * @param {number} [queryParams.priceTo] - 无描述 (可选)
	 * @param {string} [queryParams.searchKey] - 无描述 (可选)
	 * @param {integer} [queryParams.start.date] - 无描述 (可选)
	 * @param {integer} [queryParams.start.day] - 无描述 (可选)
	 * @param {integer} [queryParams.start.hours] - 无描述 (可选)
	 * @param {integer} [queryParams.start.minutes] - 无描述 (可选)
	 * @param {integer} [queryParams.start.month] - 无描述 (可选)
	 * @param {integer} [queryParams.start.nanos] - 无描述 (可选)
	 * @param {integer} [queryParams.start.seconds] - 无描述 (可选)
	 * @param {integer} [queryParams.start.time] - 无描述 (可选)
	 * @param {integer} [queryParams.start.timezoneOffset] - 无描述 (可选)
	 * @param {integer} [queryParams.start.year] - 无描述 (可选)
	 * @param {integer} [queryParams.state] - 无描述 (可选)
	 * @param {array} [queryParams.states] - 无描述 (可选)
	 * @param {integer} [queryParams.type] - 无描述 (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getManagementModuleListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/management/module/list',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * logList
	 * 接口路径: /management/module/log/list
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} [queryParams.moduleName] - 无描述 (可选)
	 * @param {integer} [queryParams.moduleVersionId] - 无描述 (可选)
	 * @param {integer} [queryParams.pageNum] - 分页 - 页码 (可选)
	 * @param {integer} [queryParams.pageSize] - 分页 - 页数 (可选)
	 * @param {integer} [queryParams.recordType] - 无描述 (可选)
	 * @param {string} [queryParams.states] - 无描述 (可选)
	 * @param {string} [queryParams.username] - 无描述 (可选)
	 * @param {string} [queryParams.version] - 无描述 (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleLogListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/management/module/log/list',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * orderList
	 * 接口路径: /management/module/order/list
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} [queryParams.catalog] - 无描述 (可选)
	 * @param {integer} [queryParams.end.date] - 无描述 (可选)
	 * @param {integer} [queryParams.end.day] - 无描述 (可选)
	 * @param {integer} [queryParams.end.hours] - 无描述 (可选)
	 * @param {integer} [queryParams.end.minutes] - 无描述 (可选)
	 * @param {integer} [queryParams.end.month] - 无描述 (可选)
	 * @param {integer} [queryParams.end.nanos] - 无描述 (可选)
	 * @param {integer} [queryParams.end.seconds] - 无描述 (可选)
	 * @param {integer} [queryParams.end.time] - 无描述 (可选)
	 * @param {integer} [queryParams.end.timezoneOffset] - 无描述 (可选)
	 * @param {integer} [queryParams.end.year] - 无描述 (可选)
	 * @param {string} [queryParams.moduleName] - 无描述 (可选)
	 * @param {string} [queryParams.orderId] - 无描述 (可选)
	 * @param {integer} [queryParams.pageNum] - 分页 - 页码 (可选)
	 * @param {integer} [queryParams.pageSize] - 分页 - 页数 (可选)
	 * @param {integer} [queryParams.start.date] - 无描述 (可选)
	 * @param {integer} [queryParams.start.day] - 无描述 (可选)
	 * @param {integer} [queryParams.start.hours] - 无描述 (可选)
	 * @param {integer} [queryParams.start.minutes] - 无描述 (可选)
	 * @param {integer} [queryParams.start.month] - 无描述 (可选)
	 * @param {integer} [queryParams.start.nanos] - 无描述 (可选)
	 * @param {integer} [queryParams.start.seconds] - 无描述 (可选)
	 * @param {integer} [queryParams.start.time] - 无描述 (可选)
	 * @param {integer} [queryParams.start.timezoneOffset] - 无描述 (可选)
	 * @param {integer} [queryParams.start.year] - 无描述 (可选)
	 * @param {integer} [queryParams.status] - 无描述 (可选)
	 * @param {integer} [queryParams.type] - 无描述 (可选)
	 * @param {string} [queryParams.username] - 无描述 (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleOrderListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/management/module/order/list',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * set module attr
	 * 接口路径: /management/module/set
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {string} bodyData.moduleName - module Name (必选)
	 * @param {string} bodyData.enNaturalName - enNaturalName (可选)
	 * @param {boolean} bodyData.enabled - enabled (可选)
	 * @param {boolean} bodyData.hotspot - hotspot (可选)
	 * @param {number} bodyData.level - level (可选)
	 * @param {string} bodyData.naturalName - naturalName (可选)
	 * @param {string} bodyData.remark - remark (可选)
	 * @param {number} bodyData.sort - sort (可选)
	 * @param {string} bodyData.sysUsername - sysUsername (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const setModuleAttrApi = (bodyData) =>
	 {
	     const config = {
	         url: '/management/module/set',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * update Module Detail
	 * 接口路径: /management/module/update/detail
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {object} bodyData - ModuleDetailUpdateRequest
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const updateModuleDetailApi = (bodyData) =>
	 {
	     const config = {
	         url: '/management/module/update/detail',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * versionList
	 * 接口路径: /management/module/version/list
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} queryParams.name - 无描述 (必选)
	 * @param {integer} [queryParams.pageNum] - 分页 - 页码 (可选)
	 * @param {integer} [queryParams.pageSize] - 分页 - 页数 (可选)
	 * @param {array} [queryParams.states] - 无描述 (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getManagementModuleVersionListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/management/module/version/list',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 /**
	 * wallet Notify
	 * 接口路径: /pay/notify/wallet
	 * 请求方法: POST
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const walletNotifyApi = () =>
	 {
	     const config = {
	         url: '/pay/notify/wallet',
	         oauth: true,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * pay order
	 * 接口路径: /pay/order
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {number} bodyData.moduleId - module Id
	 * @param {string} bodyData.payChannel - payChannel
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const payOrderApi = (bodyData = {}) =>
	 {
	     const config = {
	         url: '/pay/order',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	/**
	 * pay result
	 * 接口路径: /pay/result
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} [queryParams.orderId] - orderId (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getPayResultApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/pay/result',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 /**
	 * declarativeInfo
	 * 接口路径: /module/declarative/{fileName}
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} queryParams.fileName - fileName (必选)
	 * @param {string} [queryParams.module] - 包名 (可选)
	 * @param {string} [queryParams.version] - 版本号 (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getDeclarativeInfoApi = (queryParams = {}) =>
	 {
	     const { fileName, ...params } = queryParams;
	     const config = {
	         url: `/module/declarative/${fileName}`,
	         oauth: true,
	         params,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * download
	 * 接口路径: /module/download
	 * 请求方法: GET
	 * @param {Object} headers - 请求头参数
	 * @param {string} [headers.authorization] - authorization (可选)
	 * @param {Object} queryParams - 查询参数
	 * @param {string} [queryParams.key] - key (可选)
	 * @param {string} [queryParams.module] - module (可选)
	 * @param {integer} [queryParams.moduleFileId] - moduleFileId (可选)
	 * @param {integer} [queryParams.moduleVersionId] - moduleVersionId (可选)
	 * @param {string} [queryParams.version] - version (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const moduleDownloadApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/download',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * getModuleUrl
	 * 接口路径: /module/getModuleUrl
	 * 请求方法: GET
	 * @param {Object} headers - 请求头参数
	 * @param {string} [headers.authorization] - authorization (可选)
	 * @param {Object} queryParams - 查询参数
	 * @param {string} [queryParams.workstationId] (可选)
	 * @param {string} queryParams.moduleName (必选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleUrlApi = (queryParams = {}, env) =>
	 {
	     const config = {
	         url: '/module/searchByWorkstationId',
	         oauth: true,
	         params: queryParams,
	         headers: {
	             'Parent-Env': env
	         }
	     };
	     return roseRepoServer.get(config);
	 };
	 export const getModuleSizeApi = (queryParams = {}, env) =>
	 {
	     const config = {
	         url: '/module/getModuleUrl',
	         oauth: true,
	         params: queryParams
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * moduleInfo
	 * 接口路径: /module/info
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} [queryParams.localVersion] - 本地安装的版本号：localVersion (可选)
	 * @param {string} [queryParams.module] - module (可选)
	 * @param {string} [queryParams.version] - version (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleInfoApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/info',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * purchase
	 * 接口路径: /module/purchase
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} queryParams.module - module (必选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const modulePurchaseApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/purchase',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * searchModule
	 * 接口路径: /module/searchModule
	 * 请求方法: GET
	 * @param {Object} headers - 请求头参数
	 * @param {string} [headers.authorization] - authorization (可选)
	 * @param {Object} queryParams - 查询参数
	 * @param {string} [queryParams.arch] - arch (可选)
	 * @param {boolean} [queryParams.compiler] - 是否包含compiler (可选)
	 * @param {boolean} [queryParams.earlybird] - 是否包含earlybird (可选)
	 * @param {string} [queryParams.key] - 约定的key，<br>如果key为空或者不存在，则无法命中type=invisible或者type=plugin的包 (可选)
	 * @param {string} queryParams.module - module name， fuzzy search (必选)
	 * @param {string} [queryParams.native_os] - nativeOs，accurate matching (可选)
	 * @param {string} [queryParams.username] - username (可选)
	 * @param {string} [queryParams.version] - version, accurate matching (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const searchModuleApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/searchModule',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * upload
	 * 接口路径: /module/upload
	 * 请求方法: POST
	 * @param {Object} queryParams - 查询参数
	 * @param {string} [queryParams.arch] - arch (可选)
	 * @param {string} [queryParams.checksum] - checksum (可选)
	 * @param {string} [queryParams.cn_changelog] - cn_changelog (可选)
	 * @param {string} [queryParams.en_changelog] - en_changelog (可选)
	 * @param {string} [queryParams.native_os] - native_os (可选)
	 * @param {boolean} [queryParams.notice] - notice (可选)
	 * @param {string} [queryParams.oseExecution] - oseExecution (可选)
	 * @param {string} [queryParams.platformDependent] - platformDependent (可选)
	 * @param {FormData} formData - 表单数据
	 * @param {File} [formData.file] - 无描述 (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const moduleUploadApi = (queryParams = {}, formData) =>
	 {
	     const config = {
	         url: '/module/upload',
	         oauth: true,
	         headers: {
	             'Content-Type': 'multipart/form-data',
	         },
	         params: queryParams,
	         data: formData,
	     };
	     return roseRepoServer.post(config);
	 };
	 /***** Module Access Control *****/
	 /**
	 * getModuleAccess
	 * 接口路径: /codigger/module/access/control/getByModuleName
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} queryParams.moduleName - moduleName (必选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleAccessApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/codigger/module/access/control/getByModuleName',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * operate
	 * 接口路径: /codigger/module/access/control/operate
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {integer} queryParams.id - id (必选)
	 * @param {integer} queryParams.status - 状态：1启用，2停用 (必选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleAccessOperateApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/codigger/module/access/control/operate',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * save module access
	 * 接口路径: /codigger/module/access/control/save
	 * 请求方法: POST
	 * @param {Object} bodyData - 请求体数据
	 * @param {object} bodyData - module access control dto
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const saveModuleAccessApi = (bodyData) =>
	 {
	     const config = {
	         url: '/codigger/module/access/control/save',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	 /**
	 * details
	 * 接口路径: /moduleInstallList/details
	 * 请求方法: GET
	 * @param {Object} headers - 请求头参数
	 * @param {string} headers.authorization - authorization (必选)
	 * @param {Object} queryParams - 查询参数
	 * @param {boolean} [queryParams.enabled] - enabled (可选)
	 * @param {string} [queryParams.orderBy] - orderBy (可选)
	 * @param {string} [queryParams.sort] - sort (可选)
	 * @param {integer} [queryParams.type] - type (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getModuleInstallDetailApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/moduleInstallList/details',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	/**
	 * needUpdateModules
	 * 接口路径: /moduleInstallList/need/update/modules
	 * 请求方法: GET
	 * @param {Object} queryParams - 查询参数
	 * @param {string} [queryParams.workstationIds] - workstationIds (可选)
	 * @returns {Promise} 请求 Promise 对象
	 */
	 export const getNeedUpdateModulesApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/moduleInstallList/need/update/modules',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 export const checkModuleStatusApi = (bodyData) =>
	 {
	     const config = {
	         url: '/module/checkModuleStatus',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	 export const getInstalledListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/getInstalledList4Workstations',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 export const configChildEnvApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/configChildEnv',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 export const searchForCatalogApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/searchForCatalog',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 export const moduleSearchApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/search',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 export const versionSearchApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/version/search',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 export const getFavoritesListApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/favorites/list',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
	 export const addFavoritesApi = (bodyData) =>
	 {
	     const config = {
	         url: '/favorites/add',
	         oauth: true,
	         headers: {
	             'Content-Type': 'multipart/form-data',
	         },
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	 export const removeFavoritesApi = (bodyData) =>
	 {
	     const config = {
	         url: '/favorites/remove',
	         oauth: true,
	         headers: {
	             'Content-Type': 'multipart/form-data',
	         },
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	 export const checkWordApi = (bodyData) =>
	 {
	     const config = {
	         url: '/sensitive/word/check',
	         oauth: true,
	         data: bodyData,
	     };
	     return roseRepoServer.post(config);
	 };
	 export const getLastVersionApi = (queryParams = {}) =>
	 {
	     const config = {
	         url: '/module/getLastVersion',
	         oauth: true,
	         params: queryParams,
	     };
	     return roseRepoServer.get(config);
	 };
    export const checkExtendUrlApi = (bodyData) =>
    {
        const config = {
            url: '/extended-urls/checkExtendUrl',
            oauth: false,
            data: bodyData
        }
        return roseRepoServer.post(config);
    }
	export default {
        getCommonDownloadApi,
        uploadFileApi,
        getCopyWritingApi,
        getModuleDetailApi,
        moduleDisabledApi,
        moduleEnableApi,
        moduleInstallApi,
        moduleUninstallApi,
        moduleUpdateApi,
        getModuleByIdsApi,
        getModuleByModuleNameApi,
        getModuleVersionListApi,
        getOfferingModuleListApi,
        getModuleListApi,
        getMyModuleListApi,
        searchByWorkstationIdApi,
        getSubmissionDelistApi,
        submissionSubmitReleaseApi,
        getSubmissionResultApi,
        submissionRevokeApi,
        submissionSubmitApi,
        getTopDownloadsApi,
        checkModuleStatusApi,
        moduleUpdateDetailApi,
        getInstalledListApi,
        configChildEnvApi,
        searchForCatalogApi,
        moduleSearchApi,
        versionSearchApi,
        moduleAuditApi,
        getModuleAuditListApi,
        getManagementModuleDetailApi,
        getManagementModuleListApi,
        getModuleLogListApi,
        getModuleOrderListApi,
        setModuleAttrApi,
        updateModuleDetailApi,
        getManagementModuleVersionListApi,
        walletNotifyApi,
        payOrderApi,
        getPayResultApi,
        getDeclarativeInfoApi,
        moduleDownloadApi,
        moduleUploadApi,
        getModuleUrlApi,
        getModuleSizeApi,
        getModuleInfoApi,
        modulePurchaseApi,
        searchModuleApi,
        getModuleAccessApi,
        getModuleAccessOperateApi,
        saveModuleAccessApi,
        getModuleInstallDetailApi,
        getNeedUpdateModulesApi,
        getFavoritesListApi,
        addFavoritesApi,
        removeFavoritesApi,
        checkWordApi,
        getLastVersionApi,
        checkExtendUrlApi
	}

